import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HighscoreFilter, ILoadHighscoresPayload, IUpdateHighsciresPayload, IUserRanking } from './types';

export interface IHighscoresState {
  loading: boolean;
  exerciseId: string | null;
  isChallenge: boolean;
  page: number;
  currentUser?: IUserRanking;
  totalUsers: number;
  userList?: IUserRanking[];
  filter: HighscoreFilter;
}

export const initialState: IHighscoresState = {
  loading: false,
  exerciseId: null,
  isChallenge: false,
  page: 1,
  totalUsers: 0,
  filter: 'all',
};

export const statePropName = 'highscores';

const highscoresSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initHighscores(state) {},
    loadHighscores: {
      reducer(state, action: PayloadAction<ILoadHighscoresPayload>) {
        const { exerciseId, isChallenge } = action.payload;
        state.exerciseId = exerciseId;
        state.isChallenge = isChallenge;
      },
      /**
       * load initial page of highscores for given exercise
       * @param exerciseId internal exercise name
       */
      prepare(exerciseId: string, isChallenge: boolean) {
        return { payload: { exerciseId, isChallenge } };
      },
    },
    /**
     * load particular page of highscores for current exericise
     * @param page page number starting from 1 to load
     */
    loadHighscoresPage(state, action: PayloadAction<number>) {
      const page = action.payload;
      return {
        ...state,
        page,
        loading: true,
        currentUser: initialState.currentUser,
        totalUsers: initialState.totalUsers,
        userList: initialState.userList,
      };
    },
    updateHighscores: {
      reducer(state, action: PayloadAction<IUpdateHighsciresPayload>) {
        const { currentUser, totalUsers, userList } = action.payload;
        state.loading = false;
        state.currentUser = currentUser ?? undefined;
        state.totalUsers = totalUsers;
        state.userList = userList;
      },
      /**
       * load particular page of highscores for current exericise
       * @param currentUser current user ranking
       * @param totalUsers total amount of users in the list
       * @param userList current page of highscores
       */
      prepare(currentUser: IUserRanking | null, totalUsers: number, userList: IUserRanking[]) {
        return { payload: { currentUser, totalUsers, userList } };
      },
    },
    /**
     * change filter for highscore list
     * @param filter one of supported filters
     */
    filterHighscores(state, action: PayloadAction<HighscoreFilter>) {
      const filter = action.payload;
      return {
        ...state,
        filter,
        page: initialState.page,
        currentUser: initialState.currentUser,
        totalUsers: initialState.totalUsers,
        userList: initialState.userList,
      };
    },
    confirmParticipation(state) {},
  },
});

export const HighscoresActions = highscoresSlice.actions;
export default highscoresSlice.reducer;
